export const confirmModalStyles = {
  cancellationButtonProps: {
    fullWidth: false,
    variant: 'outlinedSecondary',
    sx: { order: 1 },
  },
  confirmationButtonProps: {
    fullWidth: false,
    variant: 'outlinedSecondary',
    sx: { order: 3 },
  },
  dialogActionsProps: {
    sx: {
      display: 'flex',
      justifyContent: 'space-between',
      padding: 3,
      paddingTop: 0,
      button: {
        borderRadius: 2,
        width: '300px',
      },
      '::after': {
        content: '"- OR -"',
        order: 2,
        fontFamily: 'Montserrat',
        textTransform: 'uppercase',
        fontWeight: 700,
      },
    },
  },
} as const;
